import mobileMenu from './pages/common/mobile-menu';
import { Callback } from "./types";

// Scripts that should be compiled into the main asset -- these should be callables
export const globals: Callback[] = [
    mobileMenu,
];

// Files that should be compiled into individual assets
export const scripts = [
    'resources/scripts/pages/home/hero.ts',
];
